<template>
  <div class="min-vh main-theme">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} EMAIL TEMPLATE
      </h1>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col>
          <InputText
            textFloat="Subject"
            placeholder="Subject"
            type="text"
            name="emailTemplateSubject"
            v-model="form.name"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <InputTextArea
            type="text"
            textFloat="Description"
            placeholder="Description"
            name="emailTemplateDescription"
            rows="20"
            v-model="form.detail"
            isRequired
            :isValidate="$v.form.detail.$error"
            :v="$v.form.detail"
            />
            <!-- :detail="`*รองรับตัวแปร {{url}} {{displayname}}`" -->
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-sm-left">
          <router-link to="/email-template">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5">CANCEL</b-button>
          </router-link>
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SettingEmailDetail",
  components: {
    InputText,
    InputTextArea,
  },
  validations() {
    return {
      form: {
        name: { required },
        detail: { required },
      },
    };
  },
  data: function() {
    return {
      isDisabled: false,
      isLoading: false,
      id: this.$route.params.id,
      form: {
        id: 0,
        brandId: this.$route.query.brandID,
        name: "",
        detail: "",
      },
    };
  },
  created: async function() {
    this.isLoading = true;
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    if (this.id) await this.getDetail();
    this.isLoading = false;
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/Email/GetDetail/${this.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isDisabled = true;
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(`${this.$baseUrl}/Email/CreateUpdate`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
    async handleSuccess(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : msg });
      this.$router.push({ path: `/email-template` }).catch(() => {});
    },
    async handleFail(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : msg }); 
    },
  },
};
</script>

<style lang="scss" scoped>
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
